<template>
    <footer class="x-footer">
        <x-container fluid app-width>
            <x-layout justify-space-between align-center>
                <x-flex xs3>
                    <div class="x-footer__links mb-3">
                        <ul>
                            <li>
                                <a href="https://www.howdengroup.com/howden-privacy-data-protection-policy" target="_blank">Privacy Policy</a>
                            </li>
                        </ul>
                    </div>

                    <div class="x-footer__copyright">
                        <p>&copy; {{ new Date().getFullYear() }} xTrade Core. One Creechurch place, London, EC3A 5AF.</p>
                    </div>
                </x-flex>

                <x-flex xs3 class="text-xs-right">
                    <span class="x-footer__powered-by">Powered by xTrade</span>
                </x-flex>
            </x-layout>
        </x-container>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    methods: {
        download() {
            axios({
                url: '/api/terms-and-conditions',
                method: 'GET',
                responseType: 'blob'
            })
                .then((response) => {
                    const url = window.URL
                        .createObjectURL(new Blob([response.data], { type: 'application/pdf;base64' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Terms & Conditions.pdf');
                    document.body.appendChild(link);
                    window.open(link);
                    document.body.removeChild(link);
                })
        }
    },
}
</script>

<style lang="scss" scoped>
.x-footer {
    background-color: $color-primary;

    .x-footer__powered-by {
        color: $color-pistachio;
        font-weight: 600;
    }

    p, a {
        letter-spacing: 0.5px;
    }
}
</style>
